import { render, staticRenderFns } from "./reporting-partner.vue?vue&type=template&id=25afd674&scoped=true&"
import script from "./reporting-partner.vue?vue&type=script&lang=js&"
export * from "./reporting-partner.vue?vue&type=script&lang=js&"
import style0 from "./reporting-partner.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reporting-partner.vue?vue&type=style&index=1&id=25afd674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25afd674",
  null
  
)

export default component.exports